import { gql } from '@apollo/client';

export const GET_CUSTOMS_CLEARANCE_TASKS = gql`
    query QueryClearanceUploadTasks(
        $filter: TaskFilterInput
        $page: Int!
        $pageSize: Int!
    ) {
        queryClearanceUploadTasks(
            filter: $filter
            page: $page
            pageSize: $pageSize
        ) {
            tasks {
                id
                taskNo
                submitterId
                submitter
                status
                totalCount
                successCount
                failedCount
                errorReason
                createdAt
                updatedAt
            }
            page
            pageSize
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

// 类型定义
export interface UploadTaskType {
    id: number;
    taskNo: string;
    submitterId: number;
    submitter: string | null;
    status: number;
    totalCount: number;
    successCount: number;
    failedCount: number;
    errorReason: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface TaskFilterInput {
    taskNo?: string | null;
    submitterId?: number | null;
    status?: number | null;
}

export interface QueryClearanceUploadTasksResponse {
    queryClearanceUploadTasks: {
        tasks: UploadTaskType[];
        page: number;
        pageSize: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export interface QueryClearanceUploadTasksVariables {
    filter?: TaskFilterInput | null;
    page: number;
    pageSize: number;
}
